import { render, staticRenderFns } from "./GoodCat.vue?vue&type=template&id=282d0cbe&scoped=true&"
import script from "./GoodCat.vue?vue&type=script&lang=js&"
export * from "./GoodCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d0cbe",
  null
  
)

export default component.exports